const BoardData =
    [
        // {
        //     id: 0,
        //     title: "Board 1",
        //     description: "Description 1",
        //     lists: [
        //         {
        //             listId: 0,
        //             listCapacity: 10,
        //             listTitle: "To-Do",
        //             listItems: []
        //         },
        //         {
        //             listId: 1,
        //             listCapacity: 10,
        //             listTitle: "In Progress",
        //             listItems: []
        //         },
        //         {
        //             listId: 2,
        //             listCapacity: 10,
        //             listTitle: "Done",
        //             listItems: []
        //         },
        //     ]
        // },
        // {
        //     id: 1,
        //     title: "Board 2",
        //     description: "Description 1",
        //     lists: [
        //         {
        //             listId: 3,
        //             listTitle: "To-Do",
        //             listItems: [
        //                 {
        //                     listId: 3,
        //                     uniqueId: 0,
        //                     description: "To-Do 1"
        //                 }, {
        //                     listId: 3,
        //                     uniqueId: 1,
        //                     description: "To-Do 2"
        //                 }, {
        //                     listId: 3,
        //                     uniqueId: 2,
        //                     description: "To-Do 3"
        //                 }
        //             ]
        //         },
        //         {
        //             listId: 4,
        //             listTitle: "In Progress",
        //             listItems: [
        //                 {
        //                     listId: 4,
        //                     uniqueId: 3,
        //                     description: "In Progress 1"
        //                 }, {
        //                     listId: 4,
        //                     uniqueId: 4,
        //                     description: "In Progress 2"
        //                 }, {
        //                     listId: 4,
        //                     uniqueId: 5,
        //                     description: "In Progress 3"
        //                 }
        //             ]
        //         },
        //         {
        //             listId: 5,
        //             listTitle: "Done",
        //             listItems: [
        //                 {
        //                     listId: 5,
        //                     uniqueId: 6,
        //                     description: "Done 1"
        //                 }, {
        //                     listId: 5,
        //                     uniqueId: 7,
        //                     description: "Done 2"
        //                 }, {
        //                     listId: 5,
        //                     uniqueId: 8,
        //                     description: "Done 3"
        //                 }
        //             ]
        //         },
        //     ]
        // },
        // {
        //     id: 2,
        //     title: "Board 3",
        //     description: "Description 1",
        //     lists: [
        //         {
        //             listId: 6,
        //             listTitle: "To-Do",
        //             listItems: [
        //                 {
        //                     listId: 6,
        //                     uniqueId: 0,
        //                     description: "To-Do 1"
        //                 }, {
        //                     listId: 6,
        //                     uniqueId: 1,
        //                     description: "To-Do 2"
        //                 }, {
        //                     listId: 6,
        //                     uniqueId: 2,
        //                     description: "To-Do 3"
        //                 }
        //             ]
        //         },
        //         {
        //             listId: 7,
        //             listTitle: "In Progress",
        //             listItems: [
        //                 {
        //                     listId: 7,
        //                     uniqueId: 3,
        //                     description: "In Progress 1"
        //                 }, {
        //                     listId: 7,
        //                     uniqueId: 4,
        //                     description: "In Progress 2"
        //                 }, {
        //                     listId: 7,
        //                     uniqueId: 5,
        //                     description: "In Progress 3"
        //                 }
        //             ]
        //         },
        //         {
        //             listId: 8,
        //             listTitle: "Done",
        //             listItems: [
        //                 {
        //                     listId: 8,
        //                     uniqueId: 6,
        //                     description: "Done 1"
        //                 }, {
        //                     listId: 8,
        //                     uniqueId: 7,
        //                     description: "Done 2"
        //                 }, {
        //                     listId: 8,
        //                     uniqueId: 8,
        //                     description: "Done 3"
        //                 }
        //             ]
        //         },
        //     ]
        // },
    ]

export default BoardData